import { bankTransfer } from '../actions/type';
import StorageService from '../services/storage.service';

const bankTransferData = StorageService.getObject('bankTransfer') || {};

const initialState = {
  selectedTransaction: bankTransferData.selectedTransaction || null,
  pendingTransactions: bankTransferData.pendingTransactions || [],
};

const bankTransferReducer = (state = initialState, action) => {
  switch (action.type) {
    case bankTransfer.SET_BANK_TRANSFER: {
      const newState = {
        ...state,
        selectedTransaction: action.payload,
      };
      StorageService.setObject('bankTransfer', newState);
      return newState;
    }

    case bankTransfer.CLEAR_BANK_TRANSFER: {
      const clearedState = {
        ...state,
        selectedTransaction: null,
        pendingTransactions: [],
      };
      StorageService.setObject('bankTransfer', clearedState);
      return clearedState;
    }

    case bankTransfer.CLEAR_SELECTED_TRANSACTION:
      return {
        ...state,
        selectedTransaction: null,
      };

    case bankTransfer.UPDATE_PENDING_TRANSACTIONS: {
      const updatedState = {
        ...state,
        pendingTransactions: action.payload,
      };
      StorageService.setObject('bankTransfer', updatedState);
      return updatedState;
    }

    default:
      return state;
  }
};

export default bankTransferReducer;
